module.exports = __webpack_public_path__ + "static/media/hbb_grid_4.19df6567.png";